import React, { useState, useEffect } from 'react';
import BreadcrumbComponent from '../../../../components/common/Breadcrumb'
import NationalEmblem from '../../../../assets/svg_main/national_emblem.svg';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Button from  '../../../../components/common/Button';
import BackArrowsvg from '../../../../assets/svg/BackArrowIconSvg.svg'
import endpoints from '@config/endpoints';
import { getData } from '../../../../services/CommonApiService'
import WomanIcon from "../../../../assets/svg_main/Woman.svg";
import ManIcon from "../../../../assets/svg_main/Man.svg";
import profilePic from '../../../../assets/png/default_profile.png'; 
import { decodeWithKeyAndShift } from '../../../../utils/base64Utils';
import LeftNavBar from '@pages/AppWrapperViewComponent/LeftNavBar';
import { CommonHamburgar } from '@components/common/CommonHamburgar';
import BadgesComponent from '@components/common/Badges';
import Unauthorised from '@components/Auth/Unauthorised';
import CheckboxComponent from '@components/common/CheckBox';
import convertByteToImageURL from '@utils/convertByteToImageURL';
import { errorLogger } from '@utils/applicationLogUtils';
import { PagePermission } from '@services/usePermission';
interface HealthFComponentProps {
  page: string;
  flow: string;

}


const MigratedBenificiaryView = (props: HealthFComponentProps,) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [imageUrl, setImageUrl] = useState<string>('');
  const [migratedBenfData, setMigratedBenfData] = useState<any>()
  const [showUnauthorized, setShowUnauthorized] = useState<boolean>(false);
  const userDetail = JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userDetails')));
  const initialFetchMigratedBenf=async ()=>{
    try{
        const response = await getData<any>(`${endpoints.getBeneficiaryById}/${id}`);
        if(response.data?.length===0){
          setShowUnauthorized(true);
        }
        else{
          const migratedBenfData=response?.data[0];
          setMigratedBenfData(migratedBenfData);
        }
        const imageRes= await getData<any>(`${endpoints.getImageByBeneficiaryID(id)}`)
            if (imageRes?.data[0]) {
                const imageurl = convertByteToImageURL(imageRes.data[0]?.image?.data);
                setImageUrl(imageurl);
            }
    }
    catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
    }
  }
  useEffect(()=>{
    initialFetchMigratedBenf();
  },[])
 
const navigateToGridPage=()=>{
    navigate(`/beneficiaries`);
}
const navigateToEdit=()=>{
    navigate(`/beneficiaries/edit/temp/${id}`);
}

const caneditBenef = PagePermission("Benf", "Benf_EdPg")
  return (
    <>
    {showUnauthorized?<Unauthorised/>:
    <div className="temp_benf_wrapper">
      <header className="view-header">
        <div className="logo-wrapper">
          <NationalEmblem className="logo" />
          <div className="name-wrapper">
            <div className="name-wrapper-title">
              JANANI
            </div>
            <div className="name-wrapper-subtext">
              Journey of Antenatal, Natal and Neonatal Integrated Care
            </div>
            <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
          </div>
        </div>
        <div className="view-route">
          <BreadcrumbComponent
            breadcrumbItemName={[
              { value: 'Service Provider', label: 'Service Provider' },
              { value: 'Migrated Beneficiary Details', label: 'Migrated Beneficiary Details' },
            ]}
          />
        </div>
      </header>
      <main className="view-content">
        <div className="view-profile-buttons">
          <div className="view-profile">
            <CommonHamburgar>
              <LeftNavBar
                navItems={['Beneficiary Details']}
                currentTab={'Beneficiary Details'}
                handleNavClick={() => { }}
              />
            </CommonHamburgar>
            <Link to={'/beneficiaries'}>
              <Button
                onClick={() => { }}
                disabled={false}
                id=""
                buttonName={''}
                colorType={'verticalbackbutton'}
                icon={<BackArrowsvg />}
                iconPosition={'left'}
              />
            </Link>
            {
              imageUrl ? <div
                className="profile-picture"
                style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : '' }}
              ></div> : <img
                className="profile-picture"
                src={profilePic}
                alt='Profile Image'
              />
            }
            <div style={{ display: "flex", flexDirection: "column", fontSize: "13px" }}>
              <div className="name">{migratedBenfData?.benf_name}</div>
              <div style={{ display: "flex", flexDirection: "row", gap: "5px", fontSize: "13px" }}>
                <div>
                  {migratedBenfData?.gender_name === 'Female' ? <WomanIcon /> : <ManIcon />}
                </div>
              </div>
            </div>
            <div>
            
            </div>
          </div>
          <div className="migrated_benf_view_cancel_edit">
                  <Button
                    onClick={navigateToGridPage}
                    disabled={false}
                    id="cancel"
                    buttonName={'Cancel'}
                    colorType={'save'}
                    icon={''}
                    iconPosition={'right'}

                  />
                  {caneditBenef &&
                  <Button
                    onClick={navigateToEdit}
                    disabled={false}
                    id={''}
                    buttonName={'Edit'}
                    colorType={'primary'}
                    iconPosition={'right'}
                  />
}
                </div>
        </div>
        <div className="content">
          <LeftNavBar
            navItems={['Beneficiary Details']}
            currentTab={'Beneficiary Details'}
            handleNavClick={() => { }}
          />
          <div className="tab-content">
              <div className="overview_beneficiary">
                <BadgesComponent
                  className="over-badge"
                  badgeName="Beneficiary Details"
                  variant="primary-1"
                  badgeType="case5"
                />
                 <div className="overview-details">
                    <div>
                        <label className="overview-personal-details-label">Beneficery Name</label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.benf_name}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">Gender</label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.gender_name}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">
                        Beneficiary DOB
                        </label>
                        <div className="overview-personal-details-value">
                        {new Date(migratedBenfData?.dob)
                            .toLocaleDateString('en-GB')
                            .slice(0, 8)
                            .replace(/\//g, '-')
                            .slice(0, 6) +
                            new Date(migratedBenfData?.dob)
                            .getFullYear()
                            .toString()
                            .slice(-4)}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">
                        Mobile Number
                        </label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.mob?migratedBenfData?.mob:'-'}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">
                        Spouse Name
                        </label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.spouse_name?migratedBenfData?.spouse_name:'-'}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">Caste</label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.category_name === 'ST'
                            ? migratedBenfData?.is_pvtg_classified
                            ? 'ST- PVTG'
                            : 'ST'
                            : migratedBenfData?.category_name}
                        </div>
                    </div>
                   
                    <div>
                        <label className="overview-personal-details-label">Religion</label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.religion_name?migratedBenfData?.religion_name:'-'}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">Others</label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.other_religion?migratedBenfData?.other_religion:'-'}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">RCH 1 ID</label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.rch_id?migratedBenfData?.rch_id:'-'}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">
                        ABHA Number
                        </label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.abha_id?migratedBenfData?.abha_id:'-'}
                        {/* <div className={isVerified ? 'verified' : 'not-verified'}>
                            {' '}
                            {isVerified ? 'Verified' : 'Not Verified'}{' '}
                        </div> */}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">
                        Alternate Phone Number
                        </label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.alternate_mob?migratedBenfData?.alternate_mob:'-'}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">State</label>
                        <div className="overview-personal-details-value">
                        {`${migratedBenfData?.state_name}-${migratedBenfData?.state_code}`}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">District</label>
                        <div className="overview-personal-details-value">
                        {`${migratedBenfData?.dist_name}-${migratedBenfData?.dist_code}`}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">Ward</label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.ward_name?migratedBenfData?.ward_name:'-'}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">Village</label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.village_name?migratedBenfData?.village_name:'-'}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">Facility Type</label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.facility_type?.length>0?migratedBenfData?.facility_type[0]:'-'}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">Facility Name</label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.facility_name?.length>0?migratedBenfData?.facility_name[0]:'-'}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">Health Provider Name</label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.health_provider_name?.length>0?migratedBenfData?.health_provider_name[0]:'-'}
                        </div>
                    </div>
                    <div>
                        <label className="overview-personal-details-label">Asha /Mobiliser Name</label>
                        <div className="overview-personal-details-value">
                        {migratedBenfData?.mobiliser_f_name?.length>0?migratedBenfData?.mobiliser_f_name[0]:'-'}
                        </div>
                    </div>
                    <CheckboxComponent
                        className="cb-overview-report"
                        checkBoxName="Enroll for SMS"
                        disabled={true}
                        onCheckboxChange={() => { }}
                        placeCheckboxBefore={false}
                        isChecked={migratedBenfData?.enroll_for_sms}
                    />
                
                    </div>               
              </div>
          </div>
        </div>
      </main>
    </div>}
    </>
  );
};

export default MigratedBenificiaryView;